import { render, staticRenderFns } from "./email-templates.vue?vue&type=template&id=8c60e6c4"
import script from "./email-templates.vue?vue&type=script&lang=js"
export * from "./email-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports